/* eslint-disable */
import $ from "jquery";
import anchorJS from "anchor-js";

class Anchors {
  constructor(el) {
    const anchors = new anchorJS(); // eslint-disable-line
    anchors.options = {
      placement: "left"
    };
    anchors.add(el);
    if (anchors.elements.length > 2) {
      this.generateTableOfContents(anchors.elements);
    }
  }

  // External code for generating a simple dynamic Table of Contents.
  generateTableOfContents(els) {
    let anchoredElText = document.createElement("UL");
    let anchoredElHref = document.createElement("UL");
    const ul = document.createElement("UL");

    const jumpLinks = document.getElementById("jumplinks");

    if (jumpLinks === null) {
      return;
    }
    
    jumpLinks.appendChild(ul);

    for (let i = 0; i < els.length; i += 1) {
      anchoredElText = els[i].textContent;
      anchoredElHref = els[i]
        .querySelector(".anchorjs-link")
        .getAttribute("href");
      els[i].querySelector(".anchorjs-link").setAttribute("aria-hidden", "true");
      this.addNavItem(ul, anchoredElHref, anchoredElText);
    }
  }

  addNavItem(ul, href, text) {
    const listItem = document.createElement("LI");
    const anchorItem = document.createElement("A");
    const textNode = document.createTextNode(text);

    anchorItem.href = href;
    ul.appendChild(listItem);
    anchorItem.appendChild(textNode);
    anchorItem.setAttribute("aria-hidden", "false");
    anchorItem.classList.add('jumplinks__link');
    listItem.appendChild(anchorItem);

    this.bindClickHandler(anchorItem, href);
  }

  bindClickHandler(el, href) {
    $(el).click(e => {
      e.preventDefault();
      let anchor = $(`a.anchorjs-link[href*="${href}"]`);
      // scroll to top
      const top = anchor.offset().top;
      $("html, body").animate({ scrollTop: top }, 500);
      // set focus at our anchor for accessibility
      anchor.focus();
      anchor.attr('aria-hidden', 'false')
    });
  }
}

export default Anchors;
/* eslint-enable */
